import { render, staticRenderFns } from "./monitorDictionary.vue?vue&type=template&id=261d9335&scoped=true"
import script from "./monitorDictionary.vue?vue&type=script&lang=js"
export * from "./monitorDictionary.vue?vue&type=script&lang=js"
import style0 from "./monitorDictionary.vue?vue&type=style&index=0&id=261d9335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d9335",
  null
  
)

export default component.exports